 /*============mobile nav Controller
	================================*/
 angular
 .module('vppApp')
 .controller('mobileNavController', mobileNavController);

 mobileNavController.$inject = ['$rootScope', '$scope', 'navFactory', '$state', '$window', 'vppConfig', '$attrs', 'AuthenticationService', 'apiFactory', 'splitFilter', '$cookies'];

 function mobileNavController($rootScope, $scope, navFactory, $state, $window, vppConfig, $attrs, AuthenticationService, apiFactory, splitFilter, $cookies) {
  //  console.log("mobile nav Controller");
   var envID = vppConfig.globalConnectSignIn[environment];
   $scope.mobileGBSignin = envID + '/samljunction/samlsso?app=ded';
   $scope.state = false;
   $rootScope.showGetAuthCTA = true;
   $scope.alreadyPressed = false;
  //  console.log(AuthenticationService.isAuthenticated());

	$scope.isAuthenticated = function (){
        return AuthenticationService.isAuthenticated();
    };
  $scope.isSupplierSite = function (){
    if($rootScope.siteCode == "sup"){
      return true;
    } else {
      return false;
    }
  }

  $scope.signInManage = function() {
    // if($cookies.get('showSignInNotice')){
    //   $window.location.href = $scope.ssoUrl;
    // }else{
    //   $state.go('sign-in-notice')
    // }

    $state.go('sign-in-notice')

  }

	// We need to Sign out the user and also toggle the state of the state variable.
    $scope.submitSignOutAndToggleState = function () {
		$scope.toggleState();
		$scope.signOutUser();
    };

	$scope.toggleState = function () {
		console.log("toggleState ~ " + $scope.state);
    $scope.state = !$scope.state;
    // If the hamburger menu is open, we should hide the CTA:
    if ($scope.state == true){
       $rootScope.showGetAuthCTA = false;
    } else {
      if ($scope.alreadyPressed == true){
        $rootScope.showGetAuthCTA = false;
      } else {
        $rootScope.showGetAuthCTA = true;
      }
    }
   };

   $scope.gcSignIn = function() {
    apiFactory.gcVerify()
      .then(function successGCSignIn(response){
        if(response.data.url != null){
          var date = new Date();
          var expirationDate = new Date(date.setMonth(date.getMonth()+6));
          $cookies.put('createAccountDirect', false, {expires: expirationDate});

          $window.location.href = response.data.url;
        }else{
            $location.path("/saml/login/" + response.data.accountId);
          }
      }, function errorCallback(response){
        // console.log(response.data.errors);
        $scope.serverError = response.data.errors;
        // called asynchronously if an error occurs
        // or server returns response with an error status.
      });
  };

   // Signout Controller
	$scope.signOutUser = function () {
        apiFactory.signOut()
                .then(function successSignOut(response) {
                    AuthenticationService.destroyAuthentication();
                    if (response.data.url != null){
                      $window.location.href = response.data.url;
                    }
                    // this callback will be called asynchronously
                    // when the response is available
                }, function errorCallback(response) {
                    // console.log(response.data.errors);
                    $scope.serverError = response.data.errors;
                    // called asynchronously if an error occurs
                    // or server returns response with an error status.
                });
	}

	 navFactory("mobileNav").then(function (response) {
		 $scope.columns = response.data.mobileNav.columns;
		//  console.log("mobile NAV ", $scope.columns);

	 });

   $scope.hideGetAuth = function () {
    $rootScope.showGetAuthCTA = false;
    $scope.alreadyPressed = true;
   }
 }
 ;
